import React, { useEffect, useState, useContext } from 'react';
import { ModeContext } from './ModeContext';
import { Tooltip, Button, IconButton, Box, Typography, LinearProgress } from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send';
import MarkdownRenderer from './MarkdownRenderer';
import RequestSupportSend from './RequestSupportSend';
import { SendToCosmos } from './SendToCosmos';
import { saveToCache, loadFromCache ,loadTitleCache} from './CacheHandler'; //チャット履歴をキャッシュに保存

const ChatDisplay = ({ onButtonClick, onSubmit,saveHistoryToCosmos }) => {
    const [editingIndex, setEditingIndex] = useState(null);
    const [editedText, setEditedText] = useState('');
    const [actionType, setActionType] = useState('');
    const [disabledButtons, setDisabledButtons] = useState([]);
    const [requestProcessed, setRequestProcessed] = useState(false); // 依頼処理完了フラグ
    const { messages, setMessages, mode, setMode, isComplete, setIsComplete, input, setInput, loginInfo,
        user,sessionId,setChatHistory, currentRequestNumber} = useContext(ModeContext);

    // 日時をフォーマットする関数
    const formatTimestamp = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}/${month}/${day} ${hours}:${minutes}`;
    };

    useEffect(() => {
        // 最後のボットメッセージにスクロール
        const lastBotMessage = document.querySelector('.bot-message:last-child');
        if (lastBotMessage) lastBotMessage.scrollIntoView({ behavior: 'smooth' });

        // ボタン無効化管理
        setDisabledButtons(prev => {
            const newDisabled = { ...prev };
            messages.forEach((_, index) => {
                if (!newDisabled[index]) newDisabled[index] = true;
            });
            return newDisabled;
        });

        const lastMsg = messages[messages.length - 1];
        if (lastMsg?.feedbackDone) {// || actionType
            setActionType('')
            const timestamp = Date.now();
            // 最初のユーザーメッセージをタイトルとして使用
            const firstUserMessage = messages.find(msg => msg.sender === 'user');
            const title = firstUserMessage?.text ?? '未定義タイトル';
            saveHistoryToCosmos(sessionId, title, messages, timestamp, mode, setChatHistory, user);
        }
    }, [messages]);

    // 新しいセッションが開始されたときにrequestProcessedをリセット
    useEffect(() => {
        // メッセージ内に依頼処理完了を示すメッセージがあるかチェック
        const hasRequestCompleted = messages.some(msg => 
            msg.text === 'サポートに依頼しました。' || msg.text === 'キャンセルしました。'
        );
        setRequestProcessed(hasRequestCompleted);
    }, [sessionId, messages]);

    const handleButtonClick = (message, index) => {
        setDisabledButtons(prev => ({ ...prev, [index]: true }));
        setInput(message.label || '');
        onButtonClick(message || '');
    };

    const handleEndOfTalkAct = async (action) => {
        setActionType(action.nextId)
        if (action.nextId === 'yes_support') {
            setRequestProcessed(true); // 依頼処理完了フラグを設定
            const text = await RequestSupportSend(action.nextId, mode, loginInfo, messages, currentRequestNumber);
            setMessages(prev => [...prev, { id: crypto.randomUUID(), sender: mode, text, buttons: [], feedbackDone: true, timestamp: Date.now() }]);
        } else if (action.nextId === 'no_support') {
            setMessages(prev => [...prev, { id: crypto.randomUUID(), sender: mode, text: 'キャンセルしました。', buttons: [], feedbackDone: true, timestamp: Date.now() }]);
        }
    };

    //Good,Badボタン
     const handleFeedback = async (type, id) => {
        setMessages(prev => {
            const updated = [...prev];
            const lastIndex = updated.length - 1;
            updated[lastIndex] = {
                ...updated[lastIndex],
                feedbackDone: true,
                feedback: type,
            };
            return updated;
        });

        const uppayload2 = {
            id: id,
            timestamp: Date.now(),
            feedback: type,
            groupId: localStorage.getItem('groupId') || '',
            container: "con-concierge-knowledge",
            updatetype:'some'
        };
        await SendToCosmos(uppayload2);

    };

    const botIcon = (mode, messageIcon) => {
        // メッセージにiconプロパティがあればそれを優先
        if (messageIcon) {
            return { image: messageIcon, hint: 'ボット' };
        }
        
        let image = '/images/faq.png';
        let hint = 'ボット';
        switch (mode) {
            case 'normal': image = '/images/normal.gif'; break;
            case 'support': image = '/images/support.png'; hint = 'サポートに連絡'; break;
            case 'manual': image = '/images/manual.png'; hint = '寺岡製品'; break;
            case 'faq': image = '/images/faq.png'; hint = '寺岡製品FAQ'; break;
            case 'faqchat': image = '/images/faqchat.png'; hint = '寺岡製品FAQ'; break;
            case 'sendbak': image = '/images/sendbak.png'; hint = 'センドバック依頼'; break;
            case 'chatgpt': image = '/images/chatgpt.png'; hint = 'ChatGPT'; break;
            case 'faqdoc': image = '/images/faqdoc.png'; hint = '取込んだ資料から回答'; break;
            case 'csiaction': image = '/images/csiaction.png'; hint = 'ボット'; break;
            case 'csinote': image = '/images/csiaction.png'; hint = 'CSIノート'; break;
            default: image = '/images/faq.png';
        }
        return { image, hint };
    };

    const handleResubmit = (index, editedText) => {
        const updatedMessages = messages.slice(0, index);
        const lastMessage = updatedMessages[updatedMessages.length - 1];
        const originalMessage = messages[index];

        const dummyMessage = {
            id: crypto.randomUUID(),
            label: editedText,
            mode: lastMessage.mode,
            imagemessage: originalMessage.imagemessage,
            image: originalMessage.image || null,
        };

        setIsComplete(false);
        setEditingIndex(null);
        setEditedText('');

        onSubmit(null, dummyMessage, updatedMessages);
    };

    if (!messages) return null;

    return (
        <div className="chat-window">
            {messages.map((msg, index) => (
                <div
                    key={msg.id}
                    className={`message-container ${msg.sender === 'user' ? 'user-message' : 'bot-message'}`}
                >
                    {msg.sender !== 'user' && (() => {
                        const { image, hint } = botIcon(msg.sender, msg.icon);
                        return (
                            <Tooltip title={hint} arrow>
                                <div className="message-icon">
                                    <img src={image} alt={hint} style={{ width: 35, height: 35 }} />
                                </div>
                            </Tooltip>
                        );
                    })()}

                    <div className="message-bubble">
                        <div className="message-timestamp">{formatTimestamp(msg.timestamp)}</div>
                        {msg.sender !== 'user' ? (
                            <MarkdownRenderer text={msg.text} />
                        ) : editingIndex === index ? (
                            <>
                                <textarea
                                    value={editedText}
                                    onChange={e => setEditedText(e.target.value)}
                                    rows={3}
                                    style={{ width: '100%', fontSize: 14, border: 'none',background: 'transparent', outline: 'none', resize: 'none' }}
                                />
                                {msg.image && msg.image !== 'null' && <img src={msg.image} alt="uploaded" style={{ maxWidth: 100, maxHeight: 100 }} />}
                                <div style={{ marginTop: 4 }}>
                                    <IconButton size="small" onClick={() => handleResubmit(index, editedText)} sx={{ p: 0.5 }}>
                                        <SendIcon fontSize="inherit" />
                                    </IconButton>
                                    <IconButton size="small" onClick={() => { setEditingIndex(null); setEditedText(''); }} sx={{ p: 0.5 }}>
                                        <CancelIcon fontSize="inherit" />
                                    </IconButton>
                                </div>
                            </>
                        ) : (
                            <>
                                {msg.text && <MarkdownRenderer text={msg.text} />}
                                {msg.image && msg.image !== 'null' && <img src={msg.image} alt="uploaded" style={{ maxWidth: 100, maxHeight: 100 }} />}
                                <IconButton 
                                    size="small" 
                                    onClick={() => { setEditingIndex(index); setEditedText(msg.text); }} 
                                    sx={{ ml: 1 }}
                                    disabled={requestProcessed} // 依頼処理完了後は編集不可
                                >
                                    <EditIcon fontSize="inherit" />
                                </IconButton>
                            </>
                        )}

                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            {msg.buttons && msg.buttons.map((button, i) => (
                                <Button
                                    key={i}
                                    variant="contained"
                                    onClick={() => handleButtonClick(button, index)}
                                    disabled={index !== messages.length - 1}
                                    sx={{ fontSize: 12, backgroundColor: 'cornflowerblue', minHeight: button.img ? 80 : 30 }}
                                >
                                    {button.icon && <img src={button.icon} alt="img" style={{ width: 25, height: 25 }} />}
                                    {button.label}
                                </Button>
                            ))}
                        </Box>

                        {msg.sender !== 'user' && msg.text.includes('end_of_talk') && (
                            <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                                <Button variant="contained" color="primary" onClick={() => handleEndOfTalkAct({ nextId: 'yes_support' })} disabled={index !== messages.length - 1}>依頼</Button>
                                <Button variant="outlined" color="primary" onClick={() => handleEndOfTalkAct({ nextId: 'no_support' })} disabled={index !== messages.length - 1}>キャンセル</Button>
                            </Box>
                        )}
                        { msg.sender !== 'user' && index >= 2 && index === messages.length - 1 && isComplete &&(
                        <div >
                            <Tooltip title="良い回答">
                            <IconButton size="small" color="gray" disabled={msg.feedbackDone} onClick={() => handleFeedback('good',msg.id)} >
                                <ThumbUpIcon fontSize="small" /> 
                            </IconButton>
                            </Tooltip>
                            <Tooltip title="良くない回答">
                            <IconButton size="small" color="gray" disabled={msg.feedbackDone} onClick={() => handleFeedback('bad',msg.id)}>
                                <ThumbDownIcon fontSize="small"/> 
                            </IconButton>
                            </Tooltip>
                        </div>
                        )}
                    </div>
                    {msg.sender === 'user' && (
                        <div className="message-icon">
                            <img src="/images/user-icon.jpg" alt="User" className="message-icon-inline" />
                        </div>
                    )}



                </div>
            ))}

            {messages[messages.length - 1]?.sender === 'user' && (
                <div className="loading-container">
                    <Typography variant="h6" component="h2" sx={{ marginBottom: 2, fontSize: 'small' }}>Now Loading・・・</Typography>
                    <Box sx={{ width: '50%', marginTop: 2 }}>
                        <LinearProgress sx={{ backgroundColor: 'lightgray', '& .MuiLinearProgress-bar': { backgroundColor: 'gray' } }} />
                    </Box>
                </div>
            )}
            
        </div>
    );
};

export default ChatDisplay;
